import * as React from "react";
import styled from "styled-components";

interface ContactFormInfoProps extends ContactFormInfoData {}

const ContactFormInfo = (props: ContactFormInfoProps) => {
  const {iconClassName,titleFirstLine,titleSecondLine,descriptionFirstLine,descriptionSecondLine,descriptionSecondLineBlueWord} = props;
  return (
    <ContactFormInfoContainer>
      <i className={`typcn typcn-${iconClassName}`}/>
      <ContactFormInfoTitle>
        <strong>{titleFirstLine}<br/>{titleSecondLine}</strong>
      </ContactFormInfoTitle>
      <ContactInfoDescription>
        <p>{descriptionFirstLine}</p>
        <p>{descriptionSecondLine}<span> {descriptionSecondLineBlueWord}</span>
        </p>
      </ContactInfoDescription>
    </ContactFormInfoContainer>
  )
};

const ContactFormInfoContainer = styled.div`
  flex-basis: 50%;
  text-align: center;
  @media (min-width : 993px) {
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 30px;
    padding-left: 30px;
    i {
      font-size: 160px;
      text-align: center;
      display: block;
      margin-top: -100px;
      margin-bottom: -60px;
      color: #3190E7;
    }
  }
  @media (max-width : 992px) {
    text-align: center;
    margin-top: 60px;
    margin-bottom: 40px;
    i {
      display: none;
    }
  }
`;

const ContactFormInfoTitle = styled.h3`
  color: #424242 !important;
  display: block;
  font-size: 35px !important;
  strong {
    font-weight: bold;
  }
`;

const ContactInfoDescription = styled.div`
  p {
    color: #4d4d4d;
    margin: 0;
    font-weight: 400 !important;
    font-size: 18px;
    span {
      font-weight: bold;
      color: #1976d2;
    }
  }
`;


export default ContactFormInfo


// WEBPACK FOOTER //
// ./src/layouts/contact-form-block/contact-form-info.tsx